import React, { useState } from "react";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { Box, Container, TextField, Typography } from "@material-ui/core";
import "../AdminCommonPages.css";
import axios from "axios";

const AddEquipment = ({ isShaws }) => {
  //   const classes = useStyles();
  const [equipments, setEquipments] = useState({
    equipmentType: undefined,
  });
  const handleChange = (e) => {
    setEquipments((prv) => ({
      ...prv,
      [e.target.id]: e.target.value,
    }));
  };
  const notify = () => {
    toast.success("Successfully Added !", {
      position: toast.POSITION.TOP_CENTER,
    });
  };
  const handleClick = async (e) => {
    e.preventDefault();
    try {
      await axios.post(
        "https://abc-backend.onrender.com/api/equipments/equipment",
        equipments
      );
      if (equipments) {
        notify();
        window.location.reload();
      }
    } catch (error) {
      console.log(error);
    }
  };
  return (
    <div className={"type_main"}>
      <Container>
        <Typography variant="h2">Add Equipment Type</Typography>
        <Box>
          <form noValidate autoComplete="off" className="type_form">
            <Box>
              <label htmlFor="">Equipment</label>
              <br />
              <br />
              <TextField
                id="equipmentType"
                variant="outlined"
                onChange={handleChange}
              />
            </Box>
            <Box className="type_submit_btn">
              <button className="common-btn" onClick={handleClick}>
                Add
              </button>
            </Box>
          </form>
        </Box>
        <ToastContainer
        //   position="top-right"
        //   autoClose={2000}
        //   hideProgressBar={false}
        //   newestOnTop={false}
        //   closeOnClick
        //   rtl={false}
        //   pauseOnFocusLoss
        //   draggable
        //   pauseOnHover
        //   theme="light"
        />
        {/* Same as */}
        <ToastContainer />
      </Container>
    </div>
  );
};

export default AddEquipment;
